import React from 'react';
import {
    overrideColumnVisibilities,
    overrideRowVisibilities
} from 'src/pages/OfferPage/TableSvgOrganizer/pureTableUtils';
import { TableProductCategoryIcons } from 'src/pages/OfferPage/TableSvgOrganizer/TableProductCategoryIcons';
import { QuotePlaceholderTable } from 'src/pages/OfferPage/QuotePlaceHolderTable/QuotePlaceholderTable';
import { PureTableBody } from 'src/pages/OfferPage/TableSvgOrganizer/PureTableBody';
import { CustomRow } from 'src/pages/OfferPage/TableSvgOrganizer/CustomRow';
import { ProjectQuoteUserProperties } from "src/model/api/project.model";
import { GetAllManufacturerDiscountForProjectResponse } from "src/model/api/manufacturer-discount.model";
import { Product } from "src/model/product.model";
import { ManufacturerRecommendationResponse } from "src/model/api/manufacturer-recommendation";
import { CustomMinusRow } from "src/pages/OfferPage/TableSvgOrganizer/CustomMinusRow";

export const PureTable = React.memo(function WrappedPureTable(
    {
      projectId,
      table,
      detailsEnabled,
      tablesEnabled,
      dlStarted,
      guessed,
      customRowButtonPressed,
      setCustomRowButtonPressed,
      currency,
      dispatchDownloadStates,
      icons,
      currentRowInEditing,
      setCurrentRowInEditing,
      labourCost = null,
      measurementSystem,
      quoteUserProperties,
      allManufacturerDiscountForProject,
      manufacturerRecommendationForProject,
      customItemsForRecommendation
    }: {
      projectId: number;
      table: any;
      detailsEnabled: boolean;
      tablesEnabled: boolean;
      dlStarted: boolean;
      guessed: any;
      customRowButtonPressed: any;
      setCustomRowButtonPressed: any;
      currency: string;
      dispatchDownloadStates: any;
      icons: any;
      currentRowInEditing: any;
      setCurrentRowInEditing: any;
      labourCost: any;
      measurementSystem: string;
      quoteUserProperties: ProjectQuoteUserProperties;
      allManufacturerDiscountForProject: GetAllManufacturerDiscountForProjectResponse;
      manufacturerRecommendationForProject: ManufacturerRecommendationResponse;
      customItemsForRecommendation: Product[];
    }
) {

  const [customMinusRowButtonPressed, setCustomMinusRowButtonPressed] =
    React.useState<boolean|null>(null);
  const [customMinusItem, setCustomMinusItem] = React.useState({});
  const [modifyMode, setModifyMode] = React.useState(null);

  const allCols = overrideColumnVisibilities(table, quoteUserProperties);
  const filteredRows = overrideRowVisibilities(
    table.rows,
    quoteUserProperties
  );

  const cancelCustomRow = React.useCallback(() => {
    setCustomRowButtonPressed(false);
    setCurrentRowInEditing({});
  }, [setCustomRowButtonPressed]);

  const cancelCustomMinusRow = React.useCallback(() => {
    setCustomMinusRowButtonPressed(false);
    setCurrentRowInEditing({});
  }, [setCustomMinusRowButtonPressed]);

  const neededCols = React.useMemo(() => {
    if (customRowButtonPressed || modifyMode) {
      return allCols.filter(
        (col: any) =>
          (typeof col.visible == "undefined" ||
            col.visible ||
            (col.data === "manufacturer_name" &&
            table.entitytype !== "projectcustomtable") ||
            col.data === 'net_price' ||
            (col.data === "article_number" &&
            table.entitytype !== "projectcustomtable") ||
            col.data === "custom_description") &&
          !(
            table.entitytype === "projectcustomtable" &&
            col.data === "category_name"
          )
      );
    }
    return allCols.filter(
      (col: any) =>
        (typeof col.visible == "undefined" || col.visible) &&
        !(
          table.entitytype === "projectcustomtable" &&
          col.data === "category_name"
        )
    );
  }, [allCols]);

  React.useEffect(() => {
    if (customMinusRowButtonPressed) {
    }
    setTimeout(function () {
      const elem = document.querySelector(".minus-row");
      if (elem) {
        elem.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      }
    }, 100);
  }, [customMinusRowButtonPressed]);

  React.useEffect(() => {
    if (customRowButtonPressed) {
      setTimeout(function () {
        const elem = document.querySelector(".custom-row");
        if (elem) {
          elem.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "center",
          });
        }
      }, 100);
    }
  }, [customRowButtonPressed]);

  React.useEffect(() => {
    if (
      customRowButtonPressed &&
      currentRowInEditing &&
      currentRowInEditing.entityId &&
      currentRowInEditing.entityType &&
      currentRowInEditing.rowId &&
      (currentRowInEditing.entityId !== table.id ||
        currentRowInEditing.entityType !== table.entitytype ||
        currentRowInEditing.rowId)
    ) {
      setCustomRowButtonPressed(false);
    }
  }, [customRowButtonPressed, currentRowInEditing]);

  return (
    <div
      /* className="quote-wrapper" */ data-entityid={table.id}
      data-entitytype={table.entitytype}
      className={`${table.entitytype === "roomtable" ? "pdf-room-table" : ""}`}
    >
      {tablesEnabled &&
      (filteredRows.length ||
        table.entitytype === "sectiontable" ||
        table.entitytype === "roomtable") ? (
          <>
            <TableProductCategoryIcons icons={icons} />
            <table
                className={`docu-table lightershadow quote-datatable table table-bordered table-hover order-column dataTable ${
            filteredRows.length ? "" : "remove-on-export"
          }`}
        >
          {filteredRows.length || customRowButtonPressed ? (
            <thead>
                <tr>
                  {neededCols.map((col: any) => (
                    <th
                      key={col.data}
                      style={{width: col.data === "article_number" || col.data === "manufacturer_name" || col.data === "custom_description" ? "200" : "width" in col ? col.width : "auto"}}
                    >
                      {col.title}
                    </th>
                  ))}
                </tr>
            </thead>
          ) : null}
          <tbody>
            <PureTableBody
              projectId={projectId}
              table={table}
              detailsEnabled={detailsEnabled}
              rows={filteredRows}
              neededCols={neededCols}
              allCols={allCols}
              currency={currency}
              setCustomMinusRowButtonPressed={setCustomMinusRowButtonPressed}
              setCustomMinusItem={setCustomMinusItem}
              dispatchDownloadStates={dispatchDownloadStates}
              modifyMode={modifyMode}
              setModifyMode={setModifyMode}
              icons={icons}
              currentRowInEditing={currentRowInEditing}
              setCurrentRowInEditing={setCurrentRowInEditing}
              labourCost={labourCost}
              measurementSystem={measurementSystem}
              quoteUserProperties={quoteUserProperties}
              allManufacturerDiscountForProject={allManufacturerDiscountForProject}
              manufacturerRecommendationForProject={manufacturerRecommendationForProject}
            />
            {customMinusRowButtonPressed &&
            table.entitytype !== "roomtable_count" &&
            currentRowInEditing &&
            currentRowInEditing.entityId &&
            currentRowInEditing.entityType &&
            currentRowInEditing.entityId === table.id &&
            currentRowInEditing.entityType === table.entitytype ? (
              <CustomMinusRow
                neededCols={neededCols}
                cancelCustomRow={cancelCustomMinusRow}
                entityType={table.entitytype}
                entityId={table.id}
                currency={currency}
                customItem={customMinusItem}
                setCustomItem={setCustomMinusItem}
                customMinusRowButtonPressed={customMinusRowButtonPressed}
                setCustomMinusRowButtonPressed={
                  setCustomMinusRowButtonPressed
                }
                setCurrentRowInEditing={setCurrentRowInEditing}
                measurementSystem={measurementSystem}
              />
            ) : null}
            {customRowButtonPressed &&
            table.entitytype !== "roomtable_count" &&
            currentRowInEditing &&
            currentRowInEditing.entityId &&
            currentRowInEditing.entityType &&
            currentRowInEditing.entityId === table.id &&
            currentRowInEditing.entityType === table.entitytype ? (
              <CustomRow
                neededCols={neededCols}
                cancelCustomRow={cancelCustomRow}
                entityType={table.entitytype}
                entityId={table.id}
                currency={currency}
                dispatchDownloadStates={dispatchDownloadStates}
                setCustomRowButtonPressed={setCustomRowButtonPressed}
                setCurrentRowInEditing={setCurrentRowInEditing}
                allManufacturerDiscountForProject={allManufacturerDiscountForProject}
                manufacturerRecommendationForProject={manufacturerRecommendationForProject}
                customItemsForRecommendation={customItemsForRecommendation}
              />
            ) : null}
          </tbody>
        </table>
          </>
      ) : tablesEnabled && guessed && dlStarted ? (
        <>
          <QuotePlaceholderTable rowNum={8} colNum={3} />
          <QuotePlaceholderTable rowNum={10} colNum={5} />
        </>
      ) : null}
      {/* tables are not enabled altogether */}
    </div>
  );
});
